import "./App.css";
import { Provider } from "react-redux";
import { BrowserRouter, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Routes from "./Routes/Routes";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import Nav from "./Nav";
import store from "../store";
import Spinner from "./Spinner/Spinner";
import GoogleAnalytics from "./GoogleAnalytics";

/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default () => (
  <div className="au-grid">
    <Provider store={store}>
      <Spinner />
      <ToastContainer />
      <BrowserRouter>
        <>
          <GoogleAnalytics />
          <Route component={Header} />
          <main className="au-body">
            <Nav />
            <Routes />
          </main>
          <Footer />
        </>
      </BrowserRouter>
    </Provider>
  </div>
);
